import React from "react";
import Page from "../Components/Page";
import useFetchData from "../hooks/useFetchData";
import { IScene } from "../features/scenes/types";
import SceneList from "../features/scenes/SceneList";

const ScenesPage = () => {
  const { data: scenes, isLoading } = useFetchData<IScene[]>("/scenes");
  return (
    <Page isLoading={isLoading}>{scenes && <SceneList scenes={scenes} />}</Page>
  );
};

export default ScenesPage;
